export const REQUEST_MASTER_DISHES = "REQUEST_MASTER_DISHES";
export const SET_MASTER_DISHES = "SET_MASTER_DISHES";
export const ERROR_GET_MASTER_DISHES = "ERROR_GET_MASTER_DISHES";

export const REQUEST_CREATE_MASTER_DISHES = "REQUEST_CREATE_MASTER_DISHES";
export const SUCCESS_CREATE_MASTER_DISHES = "SUCCESS_CREATE_MASTER_DISHES";
export const ERROR_CREATE_MASTER_DISHES = "ERROR_CREATE_MASTER_DISHES";

export const REQUEST_UPDATE_MASTER_DISHES = "REQUEST_UPDATE_MASTER_DISHES";
export const SUCCESS_UPDATE_MASTER_DISHES = "SUCCESS_UPDATE_MASTER_DISHES";
export const ERROR_UPDATE_MASTER_DISHES = "ERROR_UPDATE_MASTER_DISHES";

export const REQUEST_DELETE_MASTER_DISHES = "REQUEST_DELETE_MASTER_DISHES";
export const SUCCESS_DELETE_MASTER_DISHES = "SUCCESS_DELETE_MASTER_DISHES";
export const ERROR_DELETE_MASTER_DISHES = "ERROR_DELETE_MASTER_DISHES";

export const SET_MESSAGE_MASTER_DISHES = "SET_MESSAGE_MASTER_DISHES";